import { Cer } from '@reenstudio/app/core/models/cer/cer';

export const CER_LIST_MOCK: Cer[] = [
  {
    id: 1,
    description: 'CER DEMO 1',
    position_json: 'RAGUSA',
    enabled: true,
  },
  {
    id: 2,
    description: 'CER DEMO 2',
    position_json: 'RAGUSA',
    enabled: true,
  },
  {
    id: 3,
    description: 'CER DEMO 3',
    position_json: 'RAGUSA',
    enabled: true,
  },
  {
    id: 4,
    description: 'CER DEMO 4',
    position_json: 'RAGUSA',
    enabled: true,
  },
  {
    id: 5,
    description: 'CER DEMO 5',
    position_json: 'RAGUSA',
    enabled: true,
  },
];
